import { debug } from "../../utils";

export const ACTION_CHANGELOG_LIST_LOADED = "ACTION_CHANGELOG_LIST_LOADED";
export const ACTION_DEVICE_LOADED = "ACTION_DEVICE_LOADED";

export function DeviceDetailsPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_CHANGELOG_LIST_LOADED: {
            debug(`DeviceDetailsPageReducer ${ACTION_CHANGELOG_LIST_LOADED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_DEVICE_LOADED: {
            debug(`DeviceDetailsPageReducer ${ACTION_DEVICE_LOADED} is being processed...`)
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}